import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

const TenantContext = createContext();

export const useTenant = () => useContext(TenantContext);

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    const fetchTenantData = async () => {
      try {
        const tenantId = process.env.REACT_APP_TENANT_ID;
        if (!tenantId) {
          throw new Error('REACT_APP_TENANT_ID is not defined in the environment.');
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tenants/${tenantId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch tenant data');
        }
        const data = await response.json();
        
        if (isMounted) {
          setTenant(data);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message);
          console.error("Tenant fetch error:", err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchTenantData();
    
    return () => {
      isMounted = false;
    };
  }, []);

  // Memoize the context value to prevent unnecessary re-renders
  const value = useMemo(() => ({ 
    tenant, 
    loading, 
    error 
  }), [tenant, loading, error]);

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
}; 